export const API_PREFIX_ONEPLATFORM = 'oneplatform';
export const API_PATIENT_READINGS = 'patients/readings';
export const API_PATIENT_READINGS_CHART = 'patients/readings/chart';
export const API_DASHBOARD_NEXT_APPOINTMENTS = 'next-appointments';
export const API_DUE_APPOINTMENTS = 'due-appointments';
export const API_HISTORICAL_ACTIVITIES = 'historical-activities';
export const API_PATIENT_TASKS = 'patients';
export const API_ONEPLATFORM_PODS_ASSIGNMENTS = 'oneplatform/pods/assignments';
export const API_ONEPLATFORM_TASKS = 'oneplatform/tasks';
